import Imunizacao from '../pages/Imunizacao/Index'
import VacinaIdadeCerta from '../pages/Imunizacao/VacinaIdadeCerta/Index'

export default [
  {
    path: '/imunizacao',
    component: Imunizacao,
  },
  {
    path: '/imunizacao/importar-vacinas',
    component: () => import('@/pages/Imunizacao/ImportarVacinas/Index.vue'),
  },
  {
    path: '/imunizacao/vacina-idade-certa',
    component: VacinaIdadeCerta,
  },
  {
    path: '/imunizacao/campanha-gripe',
    component: () => import('@/pages/Imunizacao/CampanhaGripe/Template.vue'),
    children: [
      {
        path: '',
        component: () => import('@/pages/Imunizacao/CampanhaGripe/Index.vue'),
      },
    ],
  },
  {
    path: '/imunizacao/dose-imunizante',
    component: () => import('@/pages/Imunizacao/DoseImunizante/Template.vue'),
    children: [
      {
        path: '',
        component: () => import('@/pages/Imunizacao/DoseImunizante/Index.vue'),
      },
    ],
  },
  {
    path: '/imunizacao/divergencias-vacinas',
    component: () => import('@/pages/Imunizacao/DivergenciasVacinas/Index.vue'),
  },
  {
    path: '/imunizacao/divergencias-vacinas/vacinas-nao-enviadas',
    component: () =>
      import(
        '@/pages/Imunizacao/DivergenciasVacinas/VacinasNaoEnviadas/Template.vue'
      ),
    children: [
      {
        path: '',
        component: () =>
          import(
            '@/pages/Imunizacao/DivergenciasVacinas/VacinasNaoEnviadas/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/imunizacao/divergencias-vacinas/d3-antes-6',
    component: () =>
      import('@/pages/Imunizacao/DivergenciasVacinas/D3Antes6/Template.vue'),
    children: [
      {
        path: '',
        component: () =>
          import('@/pages/Imunizacao/DivergenciasVacinas/D3Antes6/Index.vue'),
      },
    ],
  },
  {
    path: '/imunizacao/divergencias-vacinas/vacinas-nascimento-divergente',
    component: () =>
      import(
        '@/pages/Imunizacao/DivergenciasVacinas/VacinasNascimentoDivergente/Template.vue'
      ),
    children: [
      {
        path: '',
        component: () =>
          import(
            '@/pages/Imunizacao/DivergenciasVacinas/VacinasNascimentoDivergente/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/imunizacao/divergencias-vacinas/vacinas-sem-cadastro',
    component: () =>
      import(
        '@/pages/Imunizacao/DivergenciasVacinas/VacinasSemCadastro/Template.vue'
      ),
    children: [
      {
        path: '',
        component: () =>
          import(
            '@/pages/Imunizacao/DivergenciasVacinas/VacinasSemCadastro/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/imunizacao/divergencias-vacinas/vacinas-antes-nascimento',
    component: () =>
      import(
        '@/pages/Imunizacao/DivergenciasVacinas/VacinasAntesNascimento/Template.vue'
      ),
    children: [
      {
        path: '',
        component: () =>
          import(
            '@/pages/Imunizacao/DivergenciasVacinas/VacinasAntesNascimento/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/imunizacao/vacina-idade-certa/faltosos-vacinas-0-15-anos',
    component: () =>
      import(
        '@/pages/Imunizacao/VacinaIdadeCerta/FaltososVacinas0a15anos/Template.vue'
      ),
    children: [
      {
        path: '',
        component: () =>
          import(
            '@/pages/Imunizacao/VacinaIdadeCerta/FaltososVacinas0a15anos/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/imunizacao/vacina-idade-certa/hpv-quadrivalente',
    component: () =>
      import(
        '@/pages/Imunizacao/VacinaIdadeCerta/HpvQuadrivalente/Template.vue'
      ),
    children: [
      {
        path: '',
        component: () =>
          import(
            '@/pages/Imunizacao/VacinaIdadeCerta/HpvQuadrivalente/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/imunizacao/vacina-idade-certa/acwy',
    component: () =>
      import('@/pages/Imunizacao/VacinaIdadeCerta/Acwy/Template.vue'),
    children: [
      {
        path: '',
        component: () =>
          import('@/pages/Imunizacao/VacinaIdadeCerta/Acwy/Index.vue'),
      },
    ],
  },
  {
    path: '/imunizacao/vacina-idade-certa/covid19-infantil',
    component: () =>
      import(
        '@/pages/Imunizacao/VacinaIdadeCerta/Covid19Infantil/Template.vue'
      ),
    children: [
      {
        path: '',
        component: () =>
          import(
            '@/pages/Imunizacao/VacinaIdadeCerta/Covid19Infantil/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/imunizacao/vacina-idade-certa/vacina-dengue',
    component: () =>
      import('@/pages/Imunizacao/VacinaIdadeCerta/VacinaDengue/Template.vue'),
    children: [
      {
        path: '',
        component: () =>
          import('@/pages/Imunizacao/VacinaIdadeCerta/VacinaDengue/Index.vue'),
      },
    ],
  },
  {
    path: '/imunizacao/vacina-idade-certa/criancas-dtp-em-atraso',
    component: () =>
      import(
        '@/pages/Imunizacao/VacinaIdadeCerta/CriancasComDtpEmAtraso/Template.vue'
      ),
    children: [
      {
        path: '',
        component: () =>
          import(
            '@/pages/Imunizacao/VacinaIdadeCerta/CriancasComDtpEmAtraso/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/imunizacao/vacina-idade-certa/pneumococica-10v',
    component: () =>
      import(
        '@/pages/Imunizacao/VacinaIdadeCerta/Pneumococica10V/Template.vue'
      ),
    children: [
      {
        path: '',
        component: () =>
          import(
            '@/pages/Imunizacao/VacinaIdadeCerta/Pneumococica10V/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/imunizacao/vacina-idade-certa/triplice-viral',
    component: () =>
      import('@/pages/Imunizacao/VacinaIdadeCerta/TripliceViral/Template.vue'),
    children: [
      {
        path: '',
        component: () =>
          import('@/pages/Imunizacao/VacinaIdadeCerta/TripliceViral/Index.vue'),
      },
    ],
  },
  {
    path: '/imunizacao/vacina-idade-certa/varicela',
    component: () =>
      import('@/pages/Imunizacao/VacinaIdadeCerta/Varicela/Template.vue'),
    children: [
      {
        path: '',
        component: () =>
          import('@/pages/Imunizacao/VacinaIdadeCerta/Varicela/Index.vue'),
      },
    ],
  },
  {
    path: '/imunizacao/vacina-idade-certa/tetra-viral',
    component: () =>
      import('@/pages/Imunizacao/VacinaIdadeCerta/TetraViral/Template.vue'),
    children: [
      {
        path: '',
        component: () =>
          import('@/pages/Imunizacao/VacinaIdadeCerta/TetraViral/Index.vue'),
      },
    ],
  },
]
